import controller from './projects.controller';

const template = require('./projects.html');

export default {
    controller,
    template
};
